<div class="container">
  <banner></banner>
  <router-outlet *ngIf="!isIframe"></router-outlet>
  <loading-spinner></loading-spinner>
  <popup-modal *ngIf="showGeneralError" [message]="'errors.general' | translate"></popup-modal>
</div>
